import { render } from "./InvoiceFooter.vue?vue&type=template&id=7464829b&scoped=true"
import script from "./InvoiceFooter.vue?vue&type=script&lang=js"
export * from "./InvoiceFooter.vue?vue&type=script&lang=js"

import "./InvoiceFooter.vue?vue&type=style&index=0&id=7464829b&lang=sass&scoped=true"
script.render = render
script.__scopeId = "data-v-7464829b"

export default script